import { memo } from 'react';
import { and, RankedTester, rankWith, schemaMatches, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsCellProps } from '@jsonforms/react';
import Autocomplete from './component'; // re-exports cellEnum/component

// Matches free-text string table cells — excludes enum fields (id, datatype) and x-scanValidate fields.
export const cellPropTextFieldTester: RankedTester = rankWith(
  10,
  and(
    uiTypeIs('Control'),
    schemaMatches((schema: any) =>
      schema?.type === 'string' &&
      !Array.isArray(schema?.enum) &&
      !schema?.['x-scanValidate']
    )
  )
);

export { PropIssuesContext } from './context';
export default withJsonFormsCellProps(memo(Autocomplete) as any);
